module.exports = __webpack_public_path__ + "static/media/29ADMSPC2.a8552409.jpg";